import {
  initialState,
  useProductFilterStore,
} from "~/store/productFilter.store.js";
import { useCriteriaStore } from "~/store/criteriaStore";

export const useSelectedFilter = () => {
  const filterStore = useProductFilterStore();
  const criteriaStore = useCriteriaStore();

  const items = computed(() => {
    return [
      ...specificationItems.value,
      ...labelItems.value,
      ...priceItems.value,
    ];
  });

  const specificationItems = computed(() => {
    const items = [];

    Object.entries(filterStore.params.specifications).forEach(
      ([slug, optionSlugs]) => {
        const specificationName = criteriaStore.getSpecification(slug)?.name;

        optionSlugs.forEach((optionSlug) => {
          const option = criteriaStore.getSpecificationOption(slug, optionSlug);

          if (undefined !== option) {
            items.push({
              key: slug + "_" + optionSlug,
              label: `${getLocalizedName(specificationName)}: ${getLocalizedName(option.value)}`,
              handler: () => filterStore.removeSpecification(slug, optionSlug),
            });
          }
        });
      },
    );

    return items.sort();
  });

  const labelItems = computed(() => {
    const labelTitles = {
      promotion: "@Promotion",
      novelty: "@Novelty",
      bestSeller: "@Top selling",
    };

    return filterStore.params.labels
      .map((label) => ({
        key: label,
        label: _T(labelTitles[label]),
        handler: () => filterStore.removeLabel(label),
      }))
      .sort();
  });

  const priceItems = computed(() => {
    if (
      undefined === filterStore.params.minPrice &&
      undefined === filterStore.params.maxPrice
    ) {
      return [];
    }

    return [
      {
        key:
          (filterStore.params.minPrice || 0) +
          (filterStore.params.maxPrice || criteriaStore.getPriceRange?.max),
        label: `
        ${filterStore.params.minPrice ?? criteriaStore.getPriceRange?.min}-
        ${filterStore.params.maxPrice ?? criteriaStore.getPriceRange?.max} грн`,
        handler: () => filterStore.resetPrice(),
      },
    ];
  });

  const hasItems = computed(() => 0 !== items.value.length);

  const resetItems = () => {
    const { labels, specifications, minPrice, maxPrice } = initialState();

    filterStore.params = {
      ...filterStore.params,
      labels,
      specifications,
      minPrice,
      maxPrice,
    };
  };

  return {
    items,
    hasItems,
    resetItems,
  };
};
